import { MatOption, MatOptionSelectionChange, MatOptgroup } from '@angular/material/core';
import { QueryList } from '@angular/core';

// The original approach tried to use a new Class and replace the existing MdSelect in the providers of the app module.
// This worked for JIT but broke down in AOT.
// The current approach uses a function to monkey patch the MdSelect Component at runtime inside of the AppModule Constructor

export default function(_mdSelect) {
  /** Static method from https://github.com/angular/material2/blob/master/src/lib/core/option/option.ts line 226
  Counts the amount of option group labels that precede the specified option. */
  const countGroupLabelsBeforeOption = function(
      optionIndex: number,
      options: QueryList<MatOption>,
      optionGroups: QueryList<MatOptgroup>
    ): number {

      if (optionGroups.length) {
        const optionsArray = options.toArray();
        const groups = optionGroups.toArray();
        let groupCounter = 0;

        for (let i = 0; i < optionIndex + 1; i++) {
          if (optionsArray[i].group && optionsArray[i].group === groups[groupCounter]) {
            groupCounter++;
          }
        }

        return groupCounter;
      }

      return 0;
    };

  // Determine whether the select has a value.
  _mdSelect.prototype._hasValue = function() {
    return this._selectionModel && this._selectionModel.hasValue();
  };

  // Calculates the scroll position and x- and y-offsets of the overlay panel.
  const SELECT_ITEM_HEIGHT = 48;
  const SELECT_PANEL_MAX_HEIGHT = 256;
  const SELECT_TRIGGER_HEIGHT = 30;

  // Custom _calculateOverlayPosition method on the MdSelect prototype that doesnt adjust the position of the dropdown menu.
  _mdSelect.prototype._calculateOverlayPosition = function() {
    const items = this._getItemCount();
    const panelHeight = Math.min(items * SELECT_ITEM_HEIGHT, SELECT_PANEL_MAX_HEIGHT);
    const scrollContainerHeight = items * SELECT_ITEM_HEIGHT;

    // The farthest the panel can be scrolled before it hits the bottom
    const maxScroll = scrollContainerHeight - panelHeight;
    const groupLabels = countGroupLabelsBeforeOption(0, this.options, this.optionGroups);
    this._offsetY = (SELECT_ITEM_HEIGHT - SELECT_TRIGGER_HEIGHT) / 2 * -1 - (groupLabels * SELECT_ITEM_HEIGHT);

      // Add 40 pixels to the y-axis to align dropdown below the input field
      this._offsetY = this._offsetY + 40;

    this._checkOverlayWithinViewport(maxScroll);
  };
}
